import { addTipsAmountAction } from "../../actions/booking/addTipsAmountAction";
function submit({values, dispatch}) {
    let amount = values?.amount, bookingId = values?.bookingId, currency = values?.currency, paymentType = values?.paymentType;
    dispatch(addTipsAmountAction({ bookingId, currency, amount, paymentType }))
}

export default submit;